export default __webpack_public_path__ + "static/media/034-car dealer.a0772ab4.svg";